/**
 * Allows you to compare previous vs. current props/state in functional React Effect hooks.
 *
 * Analogous to prevProps/props comparison in React 15's componentDidUpdate lifecycle method.
 *
 * See https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state.
 */

import React from 'react';

export default function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
